export enum HeraldStatus {
    Incomplete = 'incomplete',
    Complete = 'complete',
}
